import React, {useEffect} from "react";
import ListTransactionsTemplate from "../../../components/templates/transactions/listTransactionsTemplate";
import {useStores} from "../../../stores/useStores";
import {observer} from "mobx-react-lite";

export interface IListTransactionsProps {}

const ListTransactions: React.FC<IListTransactionsProps> = () => {
  const {
    uiStore: {transactionsUiStore, modalStore}
  } = useStores();

  useEffect(() => {
    transactionsUiStore
      .loadTransactions()
      .catch((error) => modalStore.openErrorModal(error));
  }, [modalStore, transactionsUiStore]);

  useEffect(() => transactionsUiStore.resetSortState);

  return (
    <ListTransactionsTemplate
      isTransactionsListLoading={transactionsUiStore.isLoadingTransactions}
    />
  );
};

export default observer(ListTransactions);
